import { render, staticRenderFns } from "./RollbackImportAction.vue?vue&type=template&id=65243b66"
import script from "./RollbackImportAction.vue?vue&type=script&lang=js"
export * from "./RollbackImportAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports